import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { ErrorBoundaryContext } from "react-use-error-boundary";
import { FirebaseContextProvider } from "context";
import App from "App";
import "styles/layout/base.css";
import "index.css";

const MOUNT_NODE = createRoot(document.getElementById("app"));

MOUNT_NODE.render(
  <ErrorBoundaryContext>
    <RecoilRoot>
      <FirebaseContextProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </FirebaseContextProvider>
    </RecoilRoot>
  </ErrorBoundaryContext>
);
